import { TileLayer } from '@deck.gl/geo-layers';

import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

const googleSatelliteLayer = () =>
  new TileLayer({
    data: [
      'https://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      'https://mt2.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      'https://mt3.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    ],
    id: 'google-satellite-layer',
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    // https://wiki.openstreetmap.org/wiki/Zoom_levels
    minZoom: 0,
    maxZoom: 20,
    // maxZoom: 18,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export { googleSatelliteLayer };
